<template>
  <div class="container is-fluid">
    <div class="">
      <b-navbar :shadow="true" :fixed-top="true">
          <template slot="brand">
              <b-navbar-item tag="router-link" :to="{ path: '/' }">
                  <span style="padding-left: 0.5em; color: #3482F6;font-size: 1.6em; font-weight: bolder;">
                    <svg style="padding-top: 0.1em; padding-bottom: -10px;" xmlns="http://www.w3.org/2000/svg" 
                    class="iconx icon-tabler icon-tabler-cube-unfolded" 
                    width="29" height="29" 
                    viewBox="0 0 24 24" 
                    stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
   <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
   <path d="M2 15h10v5h5v-5h5v-5h-10v-5h-5v5h-5z"></path>
   <path d="M7 15v-5h5v5h5v-5"></path>
</svg>


                    Metatext
                  </span>
              </b-navbar-item>
          </template>
          <template slot="start">
                <b-navbar-item tag="router-link" type="is-info" :to="{ path: '/dashboard' }" :active="'/dashboard' === $route.path">
                Dashboard
              </b-navbar-item>
              <!-- <b-navbar-item tag="router-link" type="is-info" :to="{ path: '/dashboard' }" :active="'/dashboard' === $route.path || '/projects' === $route.path.substring(0, 9)">
                Projects
              </b-navbar-item>
              <b-navbar-item tag="router-link" :to="{ path: '/explore' }" :active="$route.path === '/explore'">
                Explore
              </b-navbar-item>
              <b-navbar-item tag="a" href='https://docs.metatext.ai' target="_blank">
                Docs
              </b-navbar-item> -->
              
            
          </template>

          <template slot="end">
              <b-navbar-item tag="a" href="https://metatext.canny.io/report-an-issue" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-message-report" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
   <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
   <path d="M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"></path>
   <path d="M12 8l0 3"></path>
   <path d="M12 14l0 .01"></path>
</svg>&nbsp; Feature request
              </b-navbar-item>
              <b-navbar-item 
              tag="router-link" type="is-info" :to="{ path: `/account/${(currentUser.plan.name != false ? 'usage' : 'checkout')}` }" 
              :active="'/account' === $route.path || '/account' === $route.path.substring(0, 8)"
              v-if="currentUser">
                <span  
                    style="{ color: red; text-decoration: none;}" type="is-white">
                    <small v-if="'/projects' == $route.path.substring(0, 9)">
                        <i class="fa fa-bolt"></i>
                        {{ currentUser.creditsRemaining || 0 }}&nbsp;&nbsp;&nbsp;
                    </small>
                    
                    <b-tag v-if="currentUser && currentUser.plan && currentUser.plan.name == 'Pro'" type="is-dark">
                        PRO
                    </b-tag>
                    <b-tag v-else-if="currentUser && currentUser.plan && currentUser.plan.name == 'Enterprise'" type="is-dark">Enterprise</b-tag>
                    <b-tag v-else-if="currentUser && currentUser.plan && currentUser.plan.name" type="is-light">{{ currentUser.plan.name }}</b-tag>
                    <b-tag v-else>Upgrade</b-tag>
                    
                </span>
                
            </b-navbar-item>
            
              <b-navbar-item 
              v-else
              tag="router-link" type="is-info" :to="{ path: '/login' }" >
              Sign in
             </b-navbar-item>
              
              <b-navbar-item v-if="currentUser" tag="router-link" :to="{ path: '/account/usage' }">
                    <img
                        :src="currentUser.photoURL || `https://ui-avatars.com/api/?name=${currentUser.displayName}&background=3482F6&color=fff`"
                        alt="User avatar"
                        :rounded="true"
                    >

                      <b-navbar-dropdown is-left :label="currentUser.displayName">
                        <b-navbar-item tag="div" style="min-width: 100px">
                            
                            <h5 class="is-6">
                            {{ currentUser.displayName }} 
                            <br>
                            <span v-if="currentUser.organizationId">
                                <small>
                                    {{ currentUser.organizationId == currentUser.id ? 'Admin' : 'Editor'}}
                                </small>
                            </span>
                            <br>
                            <small>
                                {{ currentUser.organization }}
                            </small>
                            <br>
                            
                            </h5> 
                        </b-navbar-item>
                        <b-navbar-item tag="router-link" :to="{ path: '/d/pricing' }" v-if="!isProPlan()">
                            <b>Upgrade to PRO</b>
                        </b-navbar-item>
                        <b-navbar-item tag="router-link" :to="{ path: '/account/usage' }">
                            Plan usage
                        </b-navbar-item>
                        <b-navbar-item tag="router-link" :to="{ path: '/account/usage' }">
                            Billing control
                        </b-navbar-item>
                        <!-- <b-navbar-item tag="router-link" :to="{ path: '/account/checkout' }">
                            Checkout
                        </b-navbar-item> -->
                        <!-- <b-navbar-item tag="router-link" :to="{ path: '/account/settings' }">
                            Add members
                        </b-navbar-item> -->
                        <b-navbar-item tag="router-link" :to="{ path: '/account/settings' }">
                            Settings
                        </b-navbar-item>
                        <b-navbar-item tag="router-link" :to="{ path: '/account/settings' }">
                            API Key
                        </b-navbar-item>
                        <b-navbar-item tag="a" target="blank" href="https://metatext.canny.io/">
                          Feature Request
                        </b-navbar-item>
                        
                        <b-navbar-item tag="a" @click="signOut">
                          <b>Sign out</b>
                            <!-- &nbsp;<b-tag type="is-light" size="is-small">PRO</b-tag> -->
                        </b-navbar-item>

                        
                        
                    </b-navbar-dropdown>
              </b-navbar-item>
          </template>
      </b-navbar>
    </div>
    <br>
    
    
    <router-view />
    
    <div v-if="false" id="modal-mask">
      <div class="modal-container">
        <component :is="modal.component" v-bind="modal.data"></component>
      </div>
    </div>


    
  </div>
</template>


<script>

import mixin from '@/utils/sharedFunctions.js'

export default {
  mixins: [mixin],
    name: "Home",
    data() {
        return {
        };
    },
  components: {
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
  },
  methods: {
    async signOut() {
      await this.$auth.signOut();
      window.location.replace("/");
    },
    async login(){
      window.location.replace("/login");
    }
  },
  mounted(){

        (function(w,d,i,s){function l(){if(!d.getElementById(i)){var f=d.getElementsByTagName(s)[0],e=d.createElement(s);e.type="text/javascript",e.async=!0,e.src="https://canny.io/sdk.js",f.parentNode.insertBefore(e,f)}}if("function"!=typeof w.Canny){var c=function(){c.q.push(arguments)};c.q=[],w.Canny=c,"complete"===d.readyState?l():w.attachEvent?w.attachEvent("onload",l):w.addEventListener("load",l,!1)}})(window,document,"canny-jssdk","script");

        Canny('identify', {
            appID: '64133b564fd6010cb05787af',
            user: {
            // Replace these values with the current user's data
            name: this.$firebase.auth().currentUser.displayName,
            email: this.$firebase.auth().currentUser.email,
            id: this.$firebase.auth().currentUser.uid,
        
            // These fields are optional, but recommended:
            //   avatarURL: user.avatarURL,
            //   created: new Date(user.created).toISOString(),
            },
        })
  },
  created() {
      this.$store.dispatch("currentUser").then(function(){
        const payloadUsageByUser = {
                userId: this.currentUser.id,
                usagePlanId: this.currentUser.usagePlanId,
                apiKeyId: this.currentUser.apiKeyId
        }
        this.$store.dispatch("updateAPIUsageByUser", payloadUsageByUser)
    })
  },
};
</script>


<style lang="scss" scoped>

#home {
  #header {
    padding: 16px 64px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: solid 1px #e6e4e4;

    #app-logo {
      text-transform: uppercase;
      font-size: 1.5em;
      cursor: pointer;

      &:hover {
        color: #42b983;
      }
    }
    #nav {
      a {
        font-weight: bold;
        color: #2c3e50;

        &:not(:last-child) {
          margin-right: 8px;
        }

        &.router-link-exact-active {
          color: #42b983;
        }
      }
    }
  }

  #content {
    padding: 2px 64px;
  }

  #modal-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba($color: #000000, $alpha: 0.6);
    top: 0;
    left: 0;

    .modal-container {
      background: white;
      width: 500px;
      border-radius: 4px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

// fix footer to bottom
.footer {
  position: absolute;
  bottom:-30rem;
  width: 100%;
  height: 2.5rem;
  line-height: 2.5rem;
  background-color: #f5f5f5;
}
  


</style>
